import { axios } from '../../../config/connection/axios';

export const getReportJob = async (jobId: string) => {
    return await axios.get(`/report/job/${jobId}`);
}
